import request from '@/utils/request'

export function getListByPid(params) {
    return request({
        url: '/api/MoocCatalogue/GetListByPid',
        method: 'get',
        params
    })
}


export function add(data) {
    return request({
        url: '/api/MoocCatalogue/Add',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/api/MoocCatalogue/Update',
        method: 'post',
        data
    })
}

export function del(data) {
    return request({
        url: '/api/MoocCatalogue/Delete',
        method: 'post',
        data
    })
}

// 获取树形结构
export function getCatalogueTree(params) {
    return request({
        url: '/api/MoocCatalogue/GetCatalogueTree',
        method: 'get',
        params
    })
}

//获取资源树目录
export function getResourceTree(params) {
    return request({
        url: '/api/MoocCatalogue/GetResourceTree',
        method: 'get',
        params
    })
}


//上传视频 
export function AddVideo(data) {
    return request({
        url: '/api/MoocResource/Add',
        method: 'post',
        data
    })
}


// 查询目录大节点 
export function MoocGetListByPid(params) {
    return request({
        url: '/api/MoocCatalogue/GetListByPid',
        method: 'get',
        params
    })
}

// 查询练习题 列表 
export function catalogueId(params) {
    return request({
        url: '/api/MoocQuestion/Load',
        method: 'get',
        params
    })
}

// 查询文档资源 
export function GetCatalogue(params) {
    return request({
        url: '/api/MoocResource/GetCatalogue',
        method: 'get',
        params
    })
}

// 审核资源 
export function MoocCourseAudit(params) {
    return request({
        url: '/api/MoocCourse/Pass',
        method: 'get',
        params
    })
}